import React from 'react';

import styled from 'styled-components';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const Container = styled.div`
  padding-top: 20px;
`;

const SidebarMenuVendorShopAdmin = () => {
  return (
    <Container>
      <SidebarMenuCategoryHeader title={'VENDOR SHOPPING'} />
      <SidebarMenuItem to={`/communities`} label="Communities" />
    </Container>
  );
};

export default SidebarMenuVendorShopAdmin;
